/* 
  MOCK DATA ARCHIVE v4.3 - BRAND REPAIR EDITION
  Curated Urban Gardening Assets & Telemetry Data
*/

export const mockPlants = [
  {
    id: 'p1',
    name: 'Sweet Genovese Basil',
    type: 'Herb',
    sun: 'Full Sun',
    waterFreq: 'Every 2 days',
    difficulty: 'Easy',
    status: 'Healthy',
    hydration: 85,
    plantedDate: '2023-04-15',
    image: 'https://images.unsplash.com/photo-1618375531912-97cc5858f9c3?q=80&w=500&h=500&auto=format&fit=crop'
  },
  {
    id: 'p2',
    name: 'Micro Cherry Tomato',
    type: 'Vegetable',
    sun: 'Full Sun',
    waterFreq: 'Daily',
    difficulty: 'Medium',
    status: 'Fruiting',
    hydration: 60,
    plantedDate: '2023-03-10',
    image: 'https://images.unsplash.com/photo-1592841200221-a6898f307baa?q=80&w=500&h=500&auto=format&fit=crop'
  },
  {
    id: 'p3',
    name: 'Monstera Adansonii',
    type: 'Houseplant',
    sun: 'Indirect',
    waterFreq: 'Weekly',
    difficulty: 'Easy',
    status: 'Growing',
    hydration: 92,
    plantedDate: '2022-11-05',
    image: 'https://images.unsplash.com/photo-1614594975525-e45190c55d0b?q=80&w=500&h=500&auto=format&fit=crop'
  },
  {
    id: 'p4',
    name: 'French Lavender',
    type: 'Herb',
    sun: 'Full Sun',
    waterFreq: 'Every 4 days',
    difficulty: 'Medium',
    status: 'Dormant',
    hydration: 45,
    plantedDate: '2023-01-20',
    image: 'https://images.unsplash.com/photo-1528722828814-77b9b83acf65?q=80&w=500&h=500&auto=format&fit=crop'
  },
  {
    id: 'p5',
    name: 'Siberian Chives',
    type: 'Herb',
    sun: 'Partial Shade',
    waterFreq: 'Every 3 days',
    difficulty: 'Easy',
    status: 'Healthy',
    hydration: 78,
    plantedDate: '2023-05-12',
    image: 'https://images.unsplash.com/photo-1592433994363-2395d820579e?q=80&w=500&h=500&auto=format&fit=crop'
  }
];

export const mockTasks = [
  { id: 't1', title: 'Water Balcony Railing Pots', type: 'water', urgent: true, time: '08:00 AM' },
  { id: 't2', title: 'Harvest Ripe Cherry Tomatoes', type: 'harvest', urgent: false, time: '10:30 AM' },
  { id: 't3', title: 'Apply Liquid Kelp to Basil', type: 'feed', urgent: false, time: 'Tomorrow' },
];

export const mockZones = [
  { id: 'z1', name: 'South Balcony Rail', light: 'Direct', capacity: 6, current: 4, type: 'Outdoor' },
  { id: 'z2', name: 'Kitchen Sunway', light: 'Medium', capacity: 3, current: 2, type: 'Indoor' },
  { id: 'z3', name: 'Living Room Corner', light: 'Low', capacity: 4, current: 4, type: 'Indoor' },
];

export const mockSupplies = [
  { id: 's1', name: 'Premium Potting Mix', status: 'Low', amount: '2.5L left' },
  { id: 's2', name: 'Organic Seaweed Feed', status: 'Optimal', amount: '450ml' },
  { id: 's3', name: 'Neem Oil Spray', status: 'Refill Req', amount: '10ml' },
];

export const mockHarvestNotes = [
  { id: 'h1', plant: 'Genovese Basil', yield: '45g', date: '2023-08-12', quality: 'Premium' },
  { id: 'h2', plant: 'Micro Tomato', yield: '180g', date: '2023-08-10', quality: 'Good' },
];

export const demoSteps = [
  { id: 1, title: 'Bio-System Init', desc: 'Catalog your urban crop species into the secure Flora Archive.', module: 'Library', icon: 'Cpu' },
  { id: 2, title: 'Spatial Mapping', desc: 'Coordinate plant placement based on phototropic requirements.', module: 'Zones', icon: 'Map' },
  { id: 3, title: 'Rhythm Sync', desc: 'Calibrate irrigation cycles with localized sensor data.', module: 'Schedule', icon: 'Clock' },
  { id: 4, title: 'Telemetry Feed', desc: 'Monitor real-time metabolic status of your balcony ecosystem.', module: 'Dashboard', icon: 'Activity' },
  { id: 5, title: 'Harvest Protocol', desc: 'Optimize nutrient density with peak-window harvest alerts.', module: 'Harvest', icon: 'Zap' }
];